import { render } from "./DeleteReference.vue?vue&type=template&id=0d78c4d0"
import script from "./DeleteReference.vue?vue&type=script&lang=js"
export * from "./DeleteReference.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__